import React from 'react';
import {
  safeLanguageUrlPrefix,
  safeCurrentLanguage,
} from '@services/drupal-services';
import Translate from '@components/translation/translate-text-wrapper';

/**
 * Newsroom Navigation.
 */
const NewsroomNavigation: React.FC<{
  pageType?: string;
  blogType?: string | null;
  newsroomCategory?: string;
  filterBlogs?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    category: string
  ) => void;
}> = ({ pageType, blogType, newsroomCategory, filterBlogs }) => {
  const pathName = window.location.pathname;
  const currentPage = pathName.slice(pathName.lastIndexOf('/') + 1);

  /**
   * Render
   */
  return (
    <div className="newsroom-navigation-wrapper">
      <nav className="newsroom-navigation">
        <ul>
          <li>
            <a
              className={`${currentPage === 'newsroom' && 'active'}`}
              href={`/${safeLanguageUrlPrefix()}about-varian/newsroom`}>
              <Translate>Newsroom</Translate>
            </a>
          </li>
          <li>
            <a
              className={`${currentPage === 'news-items' && 'active'}`}
              href={`/${safeLanguageUrlPrefix()}about-varian/newsroom/news-items`}>
              <Translate>News Items</Translate>
            </a>
          </li>
          <li>
            <a
              className={`${currentPage === 'press-releases' && 'active'}`}
              href={`/${safeLanguageUrlPrefix()}about-varian/newsroom/press-releases`}>
              <Translate>Press Releases</Translate>
            </a>
          </li>
          <li>
            <a
              className={`${currentPage === 'blogs' && 'active'}`}
              href={`/${safeLanguageUrlPrefix()}resources-support/blogs`}>
              {safeCurrentLanguage() === 'zh-hant' ? (
                '在地資訊'
              ) : (
                <Translate>Blogs</Translate>
              )}
            </a>
          </li>
          {safeCurrentLanguage() === 'zh-hant' && (
            <li>
              <a href={`/resources-support/blogs`}>部落格</a>
            </li>
          )}
        </ul>
      </nav>
      {/* Blog filtering */}
      {safeCurrentLanguage() !== 'zh-hans' &&
        safeCurrentLanguage() !== 'fi' &&
        newsroomCategory === 'blogs' &&
        pageType !== 'homepage' &&
        filterBlogs && (
          <div className="blog-filter">
            <button
              className={`blog-category ${!blogType ? 'active' : ''}`}
              onClick={(event) => filterBlogs(event, null)}>
              <Translate>All</Translate>
            </button>
            <button
              className={`blog-category ${
                blogType === 'centerline' ? 'active' : ''
              }`}
              onClick={(event) => filterBlogs(event, 'centerline')}>
              Centerline
            </button>
            <button
              className={`blog-category ${
                blogType === 'vision' ? 'active' : ''
              }`}
              onClick={(event) => filterBlogs(event, 'vision')}>
              VISion
            </button>
          </div>
        )}
    </div>
  );
};

export default NewsroomNavigation;
